module.exports = __webpack_public_path__ + "static/media/offerDiscount.10c49b54.png";